<template>
  <v-flex lg3 sm12 xs12 pl-4 pr-4 pt-5 pb-2>
    <v-card class="mx-auto pa-8 elevation-0" outlined>
      <b>{{ $t("settingemail.dialog.title_selector") }}</b>
      <br />
      <br />
      <p style="font-size: 15px;">{{ $t("settingemail.dialog.selector_content") }}</p>
      <v-radio-group v-model="contentSelect" row>
        <v-radio
          :label="$t('settingemail.dialog.item_content_1')"
          value="subject"
        ></v-radio>
        <v-radio
          :label="$t('settingemail.dialog.item_content_2')"
          value="body"
        ></v-radio>
      </v-radio-group>
      <p>
        {{ $t("settingemail.dialog.selector_seller") }}
        <v-select
          v-model="item_seller"
          :items="$t('settingemail.dialog.itemsSeller')"
          item-text="text"
          item-value="value"
          :label="$t('settingemail.dialog.selector_label_seller')"
          outlined
          dense
          hide-details
          @input="fn_selector(item_seller)"
        ></v-select>
      </p>
      <p>
        {{ $t("settingemail.dialog.selector_buyer") }}
        <v-select
          v-model="item_buyer"
          :items="$t('settingemail.dialog.itemsBuyer')"
          item-text="text"
          item-value="value"
          :label="$t('settingemail.dialog.selector_label_buyer')"
          outlined
          dense
          hide-details
          @input="fn_selector(item_buyer)"
        ></v-select>
      </p>
      <p>
        {{ $t("settingemail.dialog.selector_document") }}
        <v-select
          v-model="item_document"
          :items="$t('settingemail.dialog.itemsDocument')"
          item-text="text"
          value="value"
          :label="$t('settingemail.dialog.selector_label_document')"
          outlined
          dense
          hide-details
          @input="fn_selector(item_document)"
        ></v-select>
      </p>
    </v-card>
  </v-flex>
</template>
<script>
import authorization from "@/authorization/authorization.js";
import { mapGetters, mapState } from "vuex";
export default {
  props: ["show", "html", "value"],
  data: function () {
    return {
      item_seller: "",
      item_buyer: "",
      item_document: "",
      contentSelect: "body",
    };
  },
  methods: {
    fn_selector(value) {
      var payload = {
        content: this.contentSelect,
        key: value,
      };
      this.$emit("fn_selector", payload);
    },
  },
  computed: {
    ...mapState(["backgroudcolor", "pageDetailcolor"]),
    ...mapGetters(["getter_dataBusiness_profile"]),
    _taxId: {
      get() {
        return this.getter_dataBusiness_profile["id_card_num"];
      },
    },
    _backgroudcolor: {
      get() {
        return this.backgroudcolor;
      },
    },
    _pageDetailcolor: {
      get() {
        return this.pageDetailcolor;
      },
    },
    _SellerBranchId: {
      get() {
        return this.getter_dataBusiness_profile["branch_no"];
      },
    },
  },
};
</script>


<style scoped>
.col-custom {
  padding: 0px !important;
}
</style>
